import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const currencySymbol = (raw) => {
  const u = (raw || "TRY").toString().trim().toUpperCase();
  return u === "EUR" || u === "EURO" ? "€" : "₺";
};
const fmtCur = (v, cur) => {
  if (v == null || v === "") return "-";
  const n = parseFloat(v);
  if (Number.isNaN(n)) return "-";
  return `${n.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ${currencySymbol(cur)}`;
};


const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const IlanFiyatLog = () => {
  document.title = "İlan Fiyat Logları | HarmanaGEL";

  const [loglar, setLoglar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLoglar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/ILAN_FIYAT_LOG?$top=500&$orderby=DEGISIM_TARIHI desc&$expand=ILANLAR($select=AD,PARA_BIRIMI)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setLoglar(result.value);
    } catch (err) {
      setError("Loglar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLoglar();
  }, []);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "İlan",
      accessorKey: "ILANLAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const i = cell.getValue();
        return i ? <span className="fw-medium">{i.AD}</span> : <span className="text-muted">İlan #{cell.row.original.ILAN_ID}</span>;
      },
    },
    {
      header: "Eski Fiyat",
      accessorKey: "ESKI_FIYAT",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        const cur = cell.row.original.ILANLAR?.PARA_BIRIMI;
        return v != null ? <span className="text-muted text-decoration-line-through">{fmtCur(v, cur)}</span> : "-";
      },
    },
    {
      header: "Yeni Fiyat",
      accessorKey: "YENI_FIYAT",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => (
        <span className="fw-bold text-success">
          {fmtCur(cell.getValue() || 0, cell.row.original.ILANLAR?.PARA_BIRIMI)}
        </span>
      ),
    },
    {
      header: "Fark",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const row = cell.row.original;
        const eski = parseFloat(row.ESKI_FIYAT || 0);
        const yeni = parseFloat(row.YENI_FIYAT || 0);
        const fark = yeni - eski;
        const cur = row.ILANLAR?.PARA_BIRIMI;
        if (fark === 0) return <Badge color="secondary">{fmtCur(0, cur)}</Badge>;
        const sign = fark > 0 ? "+" : "-";
        return <Badge color={fark > 0 ? "success" : "danger"}>{sign}{fmtCur(Math.abs(fark), cur)}</Badge>;
      },
    },
    {
      header: "Değişim Tarihi",
      accessorKey: "DEGISIM_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleString("tr-TR") : "-";
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="İlan Fiyat Logları" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">İlan Fiyat Değişim Geçmişi</h4>
                    <Button color="primary" size="sm" onClick={fetchLoglar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={loglar}
                      isGlobalFilter={true}
                      SearchPlaceholder="İlan ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IlanFiyatLog;
